import React, { useState } from "react";

import Loading from "../../../../Components/Interactive/Loading";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Five9Table from "./Five9/Five9Table";

const CustomerFive9Widget = ({ allCustomerData, loading }) => {
  const {
    userCallLog: { callLog },
  } = allCustomerData;

  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  return (
    <div className="user-data-container">
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <>
          <div className="customer-widget-header">
            <p
              className="customer-widget-heading"
              style={{ width: "100%", padding: ".5rem .5rem" }}
            >
              Five 9 Call Log
              <ArrowDropDownIcon
                onClick={() => {
                  setIsOpen(!open);
                  setToggleDropdown(!toggleDropdown);
                }}
                className={`arrow-dropdown ${
                  toggleDropdown ? "arrow-open" : "arrow-close"
                }`}
              />
            </p>
            {!open && (
              <p className="closed-details-text"
              >
                Total Logs - {callLog.length}
              </p>
            )}
          </div>
          <div
            className={`${
              open ? "show-data-table-call" : "no-data-table-call"
            }`}
          >
            {callLog && callLog.length >= 0 && (
              <Five9Table
                callLogs={callLog}
                totalCallLogs={callLog.length}
                open={open}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CustomerFive9Widget;
